exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VlCalendar .flatpickr-calendar {\n  width: 100%;\n}\n.VlCalendar .flatpickr-days {\n  width: 100%;\n}\n.VlCalendar .dayContainer {\n  width: 100%;\n  min-width: none;\n  max-width: none;\n}", ""]);

// exports
